export default [
  {
    "input": "docx",
    "output": "docx",
    "slug": "docx2docx"
  },
  {
    "input": "docx",
    "output": "sam",
    "slug": "docx2sam"
  },
  {
    "input": "sam",
    "output": "idtt",
    "slug": "sam2idtt"
  },
  {
    "input": "sam",
    "output": "docx",
    "slug": "sam2docx"
  },
  {
    "input": "sam",
    "output": "scml",
    "slug": "sam2scml"
  },
  {
    "input": "indd",
    "output": "sam",
    "slug": "indd2sam"
  },
  {
    "input": "scml",
    "output": "epub3",
    "slug": "scml2epub3"
  },
  {
    "input": "scml",
    "output": "idtt",
    "slug": "scml2idtt"
  },
  {
    "input": "scml",
    "output": "docx",
    "slug": "scml2docx"
  },
  {
    "input": "scml",
    "output": "html",
    "slug": "scml2html"
  },
  {
    "input": "docx",
    "output": "idtt",
    "slug": "docx2idtt"
  },
  {
    "input": "docx",
    "output": "scml",
    "slug": "docx2scml"
  },
  {
    "input": "docx",
    "output": "epub3",
    "slug": "docx2epub3"
  },
  {
    "input": "docx",
    "output": "html",
    "slug": "docx2html"
  },
  {
    "input": "sam",
    "output": "epub3",
    "slug": "sam2epub3"
  },
  {
    "input": "sam",
    "output": "html",
    "slug": "sam2html"
  },
  {
    "input": "indd",
    "output": "epub3",
    "slug": "indd2epub3"
  },
  {
    "input": "indd",
    "output": "idtt",
    "slug": "indd2idtt"
  },
  {
    "input": "indd",
    "output": "scml",
    "slug": "indd2scml"
  },
  {
    "input": "indd",
    "output": "docx",
    "slug": "indd2docx"
  },
  {
    "input": "indd",
    "output": "html",
    "slug": "indd2html"
  },
  {
    "input": "scml",
    "output": "pdf",
    "slug": "scml2pdf"
  },
  {
    "input": "scml",
    "output": "scml",
    "slug": "scml2scml"
  }
]